import { createAction } from '../../../../store.model';
import { ChatCategory } from '../model/chat-category.model';
import { ActionType } from '../teamschat-summary.action';

export interface Load {
    userId: number;
}

export const load = createAction<ActionType, Load>(
    ActionType.TEAMS_CALL__TCS__LOAD,
);

export interface LoadResult extends Load {
    chatCategories?: ChatCategory[];
}

export const loadResult = createAction<ActionType, LoadResult>(
    ActionType.TEAMS_CALL__TCS__LOAD_RESULT,
);
